import classNames from 'classnames';
import { PLPGroupedFacetValue } from 'common/types/plp-data';
import React from 'react';
import CheckboxGroup from '../CheckboxGroup';
import Fieldset from '../Fieldset';
import styles from './BrandFacetGroup.module.css';

type FacetItem = {
  label: string;
  value: string;
  name: string;
  count: number;
  dataTestId?: string;
  isDisabled?: boolean;
  status: string;
  onChange?: (event: React.FormEvent<HTMLInputElement>) => void;
  analyticsId?: string;
  groupID?: string;
};
export type FacetBrandItem = {
  group: string;
  items: FacetItem[];
};

type CheckboxGroupBrandProps = {
  className?: string;
  groupDescription: string;
  groups: PLPGroupedFacetValue[];
  dataTestId?: string;
  onChange: (event: React.FormEvent<HTMLElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLElement>) => void;
  groupID?: string;
};

export function BrandFacetGroup({
  className,
  dataTestId: groupTestId,
  groupDescription,
  groups,
  onChange,
  onKeyDown,
  groupID,
}: CheckboxGroupBrandProps) {
  return (
    <Fieldset
      key={groupDescription}
      className={classNames('fuse-checkbox-group fuse-checkbox-group--brand', className)}
      dataTestId={groupTestId}
      legend={groupDescription}
    >
      {groups.map(({ group, items }, idx) => (
        <div key={`${group}-${idx}`} className={styles.brandFacetGroup__brandGroup}>
          <div className={styles.brandFacetGroup__brandGroupName}>{group}</div>

          <CheckboxGroup
            groupDescription={`List of filters ${group}`}
            items={items}
            isFullWidth
            onChange={onChange}
            onKeyDown={onKeyDown}
            groupID={groupID}
          />
        </div>
      ))}
    </Fieldset>
  );
}
